var _path, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49779 1C7.14155 1.00042 5.81081 1.36881 4.64732 2.06594C3.48383 2.76306 2.53116 3.76281 1.89078 4.95869C1.25039 6.15458 0.946282 7.50182 1.01083 8.85692C1.07538 10.212 1.50617 11.5242 2.25732 12.6538L1 16L5.21029 15.2384C6.22413 15.734 7.33669 15.9943 8.46508 15.9999C9.59347 16.0055 10.7086 15.7562 11.7273 15.2707C12.7459 14.7852 13.642 14.076 14.3484 13.1958C15.0549 12.3158 15.5538 11.2875 15.8076 10.1877C16.0616 9.08793 16.0642 7.94501 15.815 6.84413C15.5658 5.74325 15.0716 4.71282 14.3689 3.82965C13.6662 2.94646 12.7733 2.23333 11.7567 1.74339C10.7402 1.25344 9.62619 0.999335 8.49779 1Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.71421,
    cy: 8.5001,
    r: 1.08164,
    stroke: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.49985,
    cy: 8.5001,
    r: 1.08164,
    stroke: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.2857,
    cy: 8.5001,
    r: 1.08164,
    stroke: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.01a5e65bc6c7ed31b4474eb7d5b96bc3.svg";
export { ForwardRef as ReactComponent };